import { request } from '@aqx-core/common/request';

import { IGetOptionListParams, TOptionChainData } from '../model';

export default {
  getOptionList: (params?: IGetOptionListParams, signal?: AbortSignal) =>
    request.get<TOptionChainData[]>('/api/chart/v1/option', { params, signal })
};
